export const localities = [
    {
        name: 'Arjan',
        slug: 'arjan',
        projectImage: 'https://images.unsplash.com/photo-1723539584991-89b593827a8f?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        href: '/locations/arjan',
        about: 'Arjan is a billion-dollar master-planned freehold mixed-use community development project located within the DubaiLand.'
    },
    {
        name: 'Business Bay',
        slug: 'business-bay',
        projectImage: 'https://images.unsplash.com/photo-1721804222977-7c17a905a83a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        href: '/locations/business-bay',
        about: 'Business Bay is a central business district in Dubai, United Arab Emirates. It features numerous skyscrapers located in an area where Dubai Creek has been dredged and extended.'
    },
    {
        name: 'Damac Hills',
        slug: 'damac-hills',
        projectImage: 'https://media.istockphoto.com/id/1175684910/photo/aerial-view-on-skyscrapers-of-dubai-uae-on-a-summer-day.webp?a=1&b=1&s=612x612&w=0&k=20&c=YGyaj_bdQYx4gFA41ZdOUTPRKB3RluMFn_CF0dJuarU=',
        href: '/locations/damac-hills',
        about: 'Damac Hills is a well-established self-contained community comprising villas, apartments and a hotel. Home to the Trump International Golf Club Dubai.'
    },
    {
        name: 'Downtown Dubai',
        slug: 'downtown-dubai',
        projectImage: 'https://images.unsplash.com/photo-1680901646103-89505144bd31?q=80&w=735&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        href: '/locations/downtown-dubai',
        about: 'Downtown Dubai is the city’s busy tourism hub, home to the towering Burj Khalifa skyscraper, with its observation deck, and the dancing Dubai Fountain.'
    },
    {
        name: 'Dubai Creek Harbour',
        slug: 'dubai-creek-harbour',
        projectImage: 'https://images.unsplash.com/photo-1620982604507-829904f347d0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzR8fER1YmFpJTIwQ3JlZWslMjBIYXJib3VyJTIwZHViYWl8ZW58MHx8MHx8fDA%3D',
        href: '/locations/dubai-creek-harbour',
        about: 'Dubai Creek Harbour is a sustainable, walkable and self-contained mega city that is destined to rewrite the future of Dubai.'
    },
    {
        name: 'Dubai Hills Estate',
        slug: 'dubai-hills-estate',
        projectImage: 'https://images.unsplash.com/photo-1732360489182-4ecc94d72b7b?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        href: '/locations/dubai-hills-estate',
        about: 'Dubai Hills Estate is a luxury residential area located within Mohammed bin Rashid City, home to the 18-hole championship golf course.'
    },
    {
        name: 'Dubai Investment Park',
        slug: 'dubai-investment-park',
        projectImage: 'https://images.unsplash.com/photo-1465415074239-84142598d04d?q=80&w=1174&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        href: '/locations/dubai-investment-park',
        about: 'Dubai Investments Park is a unique, self-contained mixed-use industrial, commercial and residential complex operated by Dubai Investments Park Development Company LLC.'
    },
    {
        name: 'Dubai Marina',
        slug: 'dubai-marina',
        projectImage: 'https://images.unsplash.com/photo-1723642503599-b89a44107686?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8RHViYWklMjBNYXJpbmElMjBkdWJhaXxlbnwwfHwwfHx8MA%3D%3D',
        href: '/locations/dubai-marina',
        about: 'Dubai Marina is an affluent residential neighborhood known for The Beach at JBR, a leisure complex with al fresco dining and sandy stretches to relax on.'
    },
    {
        name: 'Dubai South',
        slug: 'dubai-south',
        projectImage: 'https://images.unsplash.com/photo-1654100059389-f8423da3aa42?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGR1YmFpJTIwc291dGh8ZW58MHx8MHx8fDA%3D',
        href: '/locations/dubai-south',
        about: 'Dubai South is a master-planned city centered on the Al Maktoum International Airport, designed to sustain a population of a million people.'
    },
    {
        name: 'Dubailand',
        slug: 'dubailand',
        projectImage: 'https://plus.unsplash.com/premium_photo-1732828585135-7eb38b153b28?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8ZHViYWklMjBsYW5kfGVufDB8fDB8fHww',
        href: '/locations/dubailand',
        about: 'Dubailand is an entertainment complex being built in Dubai, United Arab Emirates, which is owned by Tatweer.'
    },
    {
        name: 'Emirates Hills',
        slug: 'emirates-hills',
        projectImage: 'https://plus.unsplash.com/premium_photo-1694475175003-9b470d82de5e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8ZW1pcmF0ZXMlMjBoaWxscyUyMGR1YmFpfGVufDB8fDB8fHww',
        href: '/locations/emirates-hills',
        about: 'Emirates Hills is a gated community located in Dubai, United Arab Emirates. It is named after Beverly Hills.'
    },
    {
        name: 'Jumeirah Beach Residence',
        slug: 'jumeirah-beach-residence',
        projectImage: 'https://images.unsplash.com/photo-1674979724572-c0a0579bc9d0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8SnVtZWlyYWglMjBCZWFjaCUyMFJlc2lkZW5jZXxlbnwwfHwwfHx8MA%3D%3D',
        href: '/locations/jumeirah-beach-residence',
        about: 'Jumeirah Beach Residence is a 1.7 kilometres long, 2 square kilometres gross floor area waterfront community located against the Persian Gulf in Dubai Marina.'
    },
    {
        name: 'Jumeirah Golf Estates',
        slug: 'jumeirah-golf-estates',
        projectImage: 'https://images.unsplash.com/photo-1662329726775-a1a976939687?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8SnVtZWlyYWglMjBHb2xmJTIwRXN0YXRlc3xlbnwwfHwwfHx8MA%3D%3D',
        href: '/locations/jumeirah-golf-estates',
        about: 'Jumeirah Golf Estates is a luxury residential golf community that is located along E 311 road, in Dubai, United Arab Emirates.'
    },
    {
        name: 'Jumeirah Lake Towers',
        slug: 'jumeirah-lake-towers',
        projectImage: 'https://images.unsplash.com/photo-1727532357114-0a6794260977?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHVtZWlyYWglMjBMYWtlJTIwVG93ZXJzfGVufDB8fDB8fHww',
        href: '/locations/jumeirah-lake-towers',
        about: 'Jumeirah Lake Towers is a large development in Dubai, United Arab Emirates which consists of 80 towers being constructed along the edges of three artificial lakes.'
    },
    {
        name: 'Jumeirah Village Circle',
        slug: 'jumeirah-village-circle',
        projectImage: 'https://images.unsplash.com/photo-1642715350691-7ffde05661c4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8SnVtZWlyYWglMjBWaWxsYWdlJTIwQ2lyY2xlfGVufDB8fDB8fHww',
        href: '/locations/jumeirah-village-circle',
        about: 'Jumeirah Village Circle is a residential community in Dubai, United Arab Emirates. It is a family-friendly development with a village-style setting.'
    },
    {
        name: 'Palm Jumeirah',
        slug: 'palm-jumeirah',
        projectImage: 'https://images.unsplash.com/photo-1682410601904-24ec1d9858e6?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8UGFsbSUyMEp1bWVpcmFofGVufDB8fDB8fHww',
        href: '/locations/palm-jumeirah',
        about: 'The Palm Jumeirah is an archipelago of artificial islands in Dubai, United Arab Emirates, created using land reclamation.'
    },
    {
        name: 'Wasl Gate',
        slug: 'wasl-gate',
        projectImage: 'https://images.unsplash.com/photo-1698923824946-1e8ab10427c7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8d2FzbCUyMGdhdGUlMjBkdWJhaXxlbnwwfHwwfHx8MA%3D%3D',
        href: '/locations/wasl-gate',
        about: 'Wasl Gate is a modern freehold master development in Dubai located near the Expo 2020 site and Jebel Ali, offering residential communities, retail, parks, and entertainment zones.'
    }
];
